// extracted by mini-css-extract-plugin
module.exports = {"maincontainer":"Bodytext_maincontainer__37ZXl","bigest":"Bodytext_bigest__1jjiR"};